import { render, staticRenderFns } from "./parameterSettings.vue?vue&type=template&id=9b27419e&"
import script from "./parameterSettings.vue?vue&type=script&lang=js&"
export * from "./parameterSettings.vue?vue&type=script&lang=js&"
import style0 from "./parameterSettings.vue?vue&type=style&index=0&id=9b27419e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports